<app-dialog [title]="data.title" [actions]="actions" (action)="action($event)" (close)="close()">
    <mat-dialog-content>
        <div class="pt-4">
            <div *ngFor="let sku of skusNotMapped">
              <app-shipment-sku [sku]="sku" [box]="true"></app-shipment-sku>
            </div>
        </div>
    </mat-dialog-content>
</app-dialog>